import React, { useContext, useState } from 'react';
import MainContext from '../../contexts/MainContext';
import ArenaStreaming from '../../data/streaming/ArenaStreaming';
import GeniusStreaming from '../../data/streaming/GeniusStreaming';
import GeniusStreamingV3 from '../../data/streaming/GeniusStreamingV3';
import RadarStreaming from '../../data/streaming/RadarStreaming';
import { getBetgeniusStreamingProps, getBetradarStreamingProps, getBetgeniusV3StreamingProps, isMatchBetgeniusStreaming, isMatchBetgeniusV3Streaming, isMatchBetradarStreaming, getArenaStreamingProps, isMatchArenaStreaming, isMatchIgameMediaStreaming, getIgameMediaStreamingProps } from '../../data/streaming/streamingUtils';
import RadarStreamingFetcher from './RadarStreamingFetcher';
import IgameMediaStreaming from '../../data/streaming/IgameMediaStreaming';
import ReactDOM from 'react-dom';
import { Rnd } from "react-rnd";
import { getConfiguration } from '../../data/utils';
import Img from '../../common/util/Img';
import { getLabel } from '../../data/labels';

function PictureInPictureContainer(props) {
    const width = 500, height = 280, marginX = 10, marginY = 35;
    return (
        ReactDOM.createPortal(
                <Rnd 
                        default={{
                        x: 0+marginX,
                        y:  document.getElementById("xsport-container")?.getBoundingClientRect().height - height - marginY ,
                        width: width,
                        height: height,
                        }}
                        minWidth={width}
                        minHeight={height}
                        bounds="window"
                >{props.children}</Rnd> ,document.getElementById('xsport-container')
        )
    )
}

export default function Streaming(props) {
    const conf = getConfiguration();
    const mainContext = useContext(MainContext);
    const streamingId = mainContext.streamingId;
    const streamingMatchId = mainContext.streamingMatchId;
    const streamingGenius = isMatchBetgeniusStreaming(mainContext.streamingProps) && getBetgeniusStreamingProps();
    const streamingGeniusV3 = isMatchBetgeniusV3Streaming(mainContext.streamingProps) && getBetgeniusV3StreamingProps();
    const streamingRadar = isMatchBetradarStreaming(mainContext.streamingProps) && getBetradarStreamingProps();
    const streamingArena = isMatchArenaStreaming(mainContext.streamingProps) && getArenaStreamingProps();
    const streamingIgameMedia = isMatchIgameMediaStreaming(mainContext.streamingProps) && getIgameMediaStreamingProps();
    const container = props.container;
    const [pictureInPicture,setPictureInPicture] = useState(false);
    const pictureInPictureEnabled = conf.spip;

    const StreamingContainer = 
            <>
                <div id="streaming-container" className={`${pictureInPictureEnabled?'streamingContainerPip':''} ${pictureInPicture?'streamingContainerPipToggled':''}`}  >
                    {pictureInPictureEnabled &&
                        <div className={'streamingContainerPipHeader'} >
                            {pictureInPicture && 
                                <> 
                                    <span>{getLabel('live_page.stream_widget.pip.drag_drop','Click here to drag and drop')}</span>
                                    <Img src="assets/img/sport/svg/pip-close-ne.svg" className="img-fluid" alt={getLabel('live_page.stream_widget.pip.toggle_off','Back to tab')} title={getLabel('live_page.stream_widget.pip.toggle_off','Back to tab')}onClick={() => {setPictureInPicture(false)} } />
                                </>
                            }
                            {!pictureInPicture && 
                               <>
                                    <span></span>
                                    <Img src="assets/img/sport/svg/pip-open-sw.svg" className="img-fluid" alt={getLabel('live_page.stream_widget.pip.toggle_on','Picture in picture')} title={getLabel('live_page.stream_widget.pip.toggle_on','Picture in picture')}  onClick={() => {setPictureInPicture(true)} } />
                               </>

                            }
                           
                        </div>
                    }
                    {streamingRadar &&
                        <RadarStreamingFetcher>
                            <RadarStreaming matchId={streamingMatchId} streamId={streamingId} />
                        </RadarStreamingFetcher>
                    }
                    {streamingArena &&
                        <ArenaStreaming matchId={streamingMatchId} streamId={streamingId} />
                    }
                    {streamingIgameMedia &&
                        <IgameMediaStreaming matchId={streamingMatchId} streamId={streamingId} />
                    }
                    {streamingGenius &&
                        <GeniusStreaming fid={streamingId} gci={streamingGenius[0].gci} />
                    }
                    {streamingGeniusV3 &&
                        <GeniusStreamingV3 fid={streamingId} confData={streamingGeniusV3[0]} isPictureInPicture={pictureInPicture} />
                    }
                </div>
            </>
   

    return (
        <>{streamingId && ((container || null) === null || container === mainContext.streamingContainer) && 
            <>{pictureInPicture?
                <>
                    <div onClick={() => {setPictureInPicture(false)} } >{getLabel('live_page.stream_widget.pip.toggled_on','Picture in picture mode')}</div>
                    <PictureInPictureContainer >
                        {StreamingContainer}
                    </PictureInPictureContainer>
                </>
            :
                <>
                    {StreamingContainer}
                </>
            }
            </>
        }
        </>
    );
}
            